import React from 'react';
import * as R from 'ramda';
import { object } from 'prop-types';

import { getAvatarUrl } from '../../../../../../utils';
import { UserIcon } from './styles';
import { Tooltip } from '../../../../../popovers';


export const ParticipantItem = ({
  participant,
  participantIconStyle,
}) => (
  <Tooltip
    title={R.pathOr('Participant not found', ['fullName'], participant)}
  >
    <UserIcon
      tabIndex={0}
      style={participantIconStyle}
      src={getAvatarUrl(R.pathOr(null, ['profileImage'], participant))}
    />
  </Tooltip>
);

ParticipantItem.propTypes = {
  participant: object,
  participantIconStyle: object,
};

ParticipantItem.defaultProps = {
  participant: {},
  participantIconStyle: {},
};



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/participants-list/participant/index.js